<!--<h2 class="addNew">
Cerca una destinazione o aggiungine una nuova
<span class="material-icons" matTooltip="Aggiungi destinazione" (click)='createNewDatasetRow()'>add</span>
</h2>-->

@if (filterFormGroup) {
  <form autocomplete="off" name='form' [formGroup]="filterFormGroup" class="fx-column fx-justify-start fx-items-stretch fx-lt-lg-justify-stretch fx-lt-lg-items-stretch">
    @if (!resellView && !readOnly) {
      <div class="base-textfield base-textfield-large">
        <form-input-viewer
          [formInputDefinition]='field'
          [formGroup]='filterFormGroup'
          [dataContainerService]='datasetACS'
          [formControlKey]='field.key'
        ></form-input-viewer>
      </div>
    }
    @if (datasetACS.loading.value) {
      <mat-progress-bar class='mt-24 mb-24' mode="indeterminate"></mat-progress-bar>
    }
    <mat-table #mytable [hidden]='dataSource.data.length === 0' [dataSource]="dataSource" class="mat-elevation-z8">
      @for (col of dynamCols; track col) {
        <ng-container [matColumnDef]='col.name'>
          <mat-header-cell *matHeaderCellDef [class.hide]='!col.show'>
            {{col.title}}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" [class.hide]='!col.show' [innerHtml]='row[col.name] | renderColumn:col.valueType'></mat-cell>
        </ng-container>
      }
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let row" class="align-end">
          @if (!resellView && !readOnly) {
            <span class="material-icons" (click)='remove(row)'>
              close
            </span>
          }
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    @if (dataSource.data.length == 0 && resellView) {
      <div>
        <h3>Nessun record presente!</h3>
      </div>
    }
    @if (!resellView && !readOnly) {
      <div class="save-button-container">
        <button
          [disabled]='rowsAdded.length === 0 && rowsRemoved.length === 0'
          class="gyg-button gyg-button-medium gyg-button-cta-light"
          (click)='onSave()'
          >
          <span>Salva e continua</span>
        </button>
      </div>
    }
  </form>
}
